import React from 'react';
import { observer } from 'mobx-react';
import { Loader, BaasicInput, BaasicSelect } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { ButtonGroup, Button } from '@progress/kendo-react-buttons';
import BasicRadio from 'themes/components/forms/BasicRadio';

const MarketplaceOrderEditShippingStepTemplate = ({
	t,
	marketplaceOrderEditViewStore: {
		form,
		loading,
		onSelectChange,
		countryOptions,
		stateOptions,
		currencyOptions,
		confirmationTypeOptions,
		debouncedCountrySearch,
		isCountryLoading,
		onMenuClose,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			<h3 className="spc--bottom--med title--primary">{t('MARKETPLACEORDEREDITFORM.TITLE.SHIPPINGSTEP')}</h3>
			<div className="row">
				<div className="col col-sml-12 col-xxlrg-8">
					<div className="row">
						<div className="col col-sml-6">
							<BaasicInput autoFocus field={form.$('shippingStep.shippingAddress1')} className="fs-mask" />
							<BaasicInput field={form.$('shippingStep.shippingAddress2')} className="fs-mask" />
							<BaasicInput field={form.$('shippingStep.shippingAddress3')} className="fs-mask" />
							<BaasicInput field={form.$('shippingStep.shippingCity')} />
							<BaasicInput field={form.$('shippingStep.shippingZipCode')} />
							<BaasicInput field={form.$('shippingStep.buyerName')} className="fs-mask" />
							<BaasicInput field={form.$('shippingStep.buyerPhone')} className="fs-mask" />
						</div>
						<div className="col col-sml-6">
							<BaasicSelect
								field={form.$('shippingStep.shippingCoreCountry')}
								value={form.$('shippingStep.shippingCoreCountry').value}
								onChange={value => onSelectChange(value, form.$('shippingStep.shippingCoreCountry'))}
								options={countryOptions.slice()}
								onInputChange={debouncedCountrySearch}
								onMenuClose={() => onMenuClose()}
								isLoading={isCountryLoading}
								className="spc--bottom--sml flex--grow--1"
							/>
							<BaasicSelect
								field={form.$('shippingStep.shippingCoreCountryState')}
								value={form.$('shippingStep.shippingCoreCountryState').value}
								options={stateOptions}
								onChange={value => onSelectChange(value, form.$('shippingStep.shippingCoreCountryState'))}
								className="spc--bottom--sml flex--grow--1"
							/>
							<BaasicSelect
								field={form.$('shippingStep.confirmationType')}
								value={form.$('shippingStep.confirmationType').value}
								options={confirmationTypeOptions}
								onChange={value => onSelectChange(value, form.$('shippingStep.confirmationType'))}
								isClearable={true}
								className="spc--bottom--sml flex--grow--1"
							/>
							<BaasicInput field={form.$('shippingStep.shippingPaid')} />
							<BaasicSelect
								field={form.$('shippingStep.currency')}
								value={form.$('shippingStep.currency').value}
								onChange={value => onSelectChange(value, form.$('shippingStep.currency'))}
								isClearable={true}
								options={currencyOptions}
								className="spc--bottom--sml flex--grow--1"
							/>
							<BaasicInput field={form.$('shippingStep.buyerEmail')} />
							<BaasicInput field={form.$('shippingStep.customerNote')} />
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default defaultTemplate(MarketplaceOrderEditShippingStepTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/wizard/MarketplaceOrderEditShippingStepTemplate.jsx